var _effectorFileName = "/builds/gmini/front-common/src/components/FilterPanel/utils/prepareConditionsForSubmit.ts";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.function.name.js";
import { conditionIsFilled } from "./conditionPropertyIsFilled";
import { prepareSourceListForApi } from "./prepareSourceListForApi";
export var prepareConditionsForSubmit = function prepareConditionsForSubmit(formData, sourceList, dependencies) {
  return {
    properties: formData.conditions.filter(conditionIsFilled).map(function (_ref) {
      var value = _ref.value,
          operator = _ref.operator,
          property = _ref.property;
      return {
        value: value,
        filterCondition: operator.value,
        propertyGroupName: property.groupName,
        propertyName: property.name
      };
    }),
    sources: prepareSourceListForApi(sourceList, dependencies)
  };
};